import {createSlice} from "@reduxjs/toolkit";

import {getCookie} from "utils/api";
import {authConstants} from "constants/authConstants";
import jwtDecode from "jwt-decode";

export const authData = (data = null, isLoading = true) => {
  return {
    isAuth: !!data,
    userId: data?.userId || "",
    right: data?.AUTHORITIES_KEY?.[0]?.authority || "",
    login: data?.sub || "",
    name: data?.userName || data?.sub || "",
    password: data?.sub || "",
    authInProcess: isLoading,
  }
}


export const authSlice = createSlice({
  name: "auth",
  initialState: authData(null, true),
  reducers: {
    setAuth: (state, {payload}) => {
      return {...state, ...payload};
    },
  },
});

export const {setAuth} = authSlice.actions;

export const CheckIsAuth = () => (dispatch) => {
  const setUserData = () => {
    let newState;
    if (getCookie(authConstants.accessToken) && getCookie(authConstants.accessToken) !== "undefined") {
      const AccessToken = getCookie(authConstants.accessToken);
      if (AccessToken) {
        let data = jwtDecode(AccessToken);
        newState = authData(data, false)
      }
    } else {
      newState = authData(null, false)
    }
    return newState
  }

  return new Promise((resolve) => {
    const newState = setUserData();
    return resolve(dispatch(setLoadAuth(newState)));
  });

}

export const getAuth = (state) => state.auth;

export const setLoadAuth = (body) => (dispatch) => {
  return new Promise((resolve) => {
    return resolve(dispatch(setAuth({...body})))
  });
}

export default authSlice.reducer;
